import { isWeb } from "@memorang/helpers/src/common";
/* -----------------Types--------------- */
import Box from "@memorang/ui/src/components/Box";
import { ProgressSummaryCard } from "@memorang/ui/src/components/Cards/ProgressSummaryCard";
import { StudySessionMasteryTagProgressCard } from "@memorang/ui/src/components/Cards/StudySessionMasteryTagProgressCard";
import { PracticeTestsCard } from "@memorang/ui/src/components/ProgressApplet/PracticeTestsCard";
/* -----------------Child components--------------- */
import ProgressCardsContainer from "@memorang/ui/src/components/ProgressApplet/ProgressCardsContainer";
import type {
	ExamCardData,
	MasteryTagProgressData,
	SummaryCardData,
} from "./types";

interface Props {
	masteryTagsProgressData: MasteryTagProgressData[];
	needsImprovementProgressData: MasteryTagProgressData | null;
	summaryCardData?: SummaryCardData;
	practiceTestsCardData?: ExamCardData;
	showStudyPackViews?: boolean;
	showPracticeTests?: boolean;
	handleClickCard: (title: string) => void;
	handleClickStudy: () => void;
	appFont: string;
	handleNavigation: (numericId: number) => void;
	progressNeedsImprovementCtaLabel: string;
	handleClickInfo?: (text: string, title: string) => void;
}
const ProgressView = ({
	masteryTagsProgressData,
	needsImprovementProgressData,
	summaryCardData,
	showStudyPackViews,
	practiceTestsCardData,
	showPracticeTests,
	handleClickCard,
	handleClickStudy,
	appFont,
	handleNavigation,
	progressNeedsImprovementCtaLabel,
	handleClickInfo,
}: Props) => {
	const masteryTagsCards = masteryTagsProgressData.map((item) => {
		return (
			<StudySessionMasteryTagProgressCard
				handleClickCard={() => handleClickCard(item.tagType!)}
				key={item.title}
				{...item}
				handleClickInfo={() =>
					handleClickInfo?.(item.tooltip!, `${item.title} progress`)
				}
			/>
		);
	});

	const cards = [
		...(practiceTestsCardData && showPracticeTests
			? [
					<PracticeTestsCard
						{...practiceTestsCardData}
						key="practice-tests-card"
						isWeb={isWeb}
						appFont={appFont}
						handleNavigation={handleNavigation}
					/>,
				]
			: []),
		...(summaryCardData
			? [
					<ProgressSummaryCard
						{...summaryCardData}
						key="summary-card"
						handleClickInfo={() =>
							handleClickInfo?.(summaryCardData.tooltip!, summaryCardData.title)
						}
					/>,
				]
			: []),
		<Box gap={16} key="mastery-tags-cards">
			{masteryTagsCards}
		</Box>,
		...(needsImprovementProgressData
			? [
					<StudySessionMasteryTagProgressCard
						showViewAll
						handleClickCard={showStudyPackViews ? handleClickStudy : undefined}
						{...needsImprovementProgressData}
						cta={
							showStudyPackViews ? progressNeedsImprovementCtaLabel : undefined
						}
						key="needs-improvement-card"
					/>,
				]
			: []),
	];
	return (
		<Box gap={16}>
			<ProgressCardsContainer cards={cards} />
		</Box>
	);
};

export default ProgressView;
